<template>
  <modal 
    name="forum-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'540px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="bg-white relative">

      <div class="flex justify-center pt-6">
        <img src="https://www.artify.co/storage/sources/6a4a7f0c-ff1d-4839-9771-073862b8607a.svg" class="inline" style="height:280px" />
      </div>

      <a href="#"
        v-on:click.prevent="close"
        class="text-gray-500 hover:text-gray-700 absolute" style="top:15px;right:15px;">
        <svg width="20" height="20" stroke-width="2" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>


      <div class="p-6">
        <div class="text-lg font-light text-gray-700">
          Join {{ getAppName }} Forum!
        </div>

        <div class="mt-2 text-base text-gray-800">
          Hello there. We recently launched {{ getAppName }} forum - a private place for you and fellow
          {{ getAppName }} users to connect, exchange ideas and also receive the latest updates on
          {{ getAppName }}.
        </div>

        <div class="button-line">
          <SubmitButton :onClick="upgrade" :loading="loading" label="Sounds great, let's go!" :isFullWidth="true" />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton   from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    data() {
      return {
        reason : null,
        loading: false
      }
    },

    methods : {
      
      beforeOpen(event) {
        this.loading = false
        // this.reason  = event.params.reason
      },

      opened(event) {
        // this.$refs.message.focus()
      },

      close() {
        this.$modal.hide('forum-modal')
      },

      upgrade() {
        window.open('https://forum.brokerpad.com.au/auth/mo/register?value=' + this.$store.state.user.email, '_blank')
      },

      // ignoreThis() {
      //   this.$cookies.set('ignore-mfa-modal', '1', 60 * 60 * 24 * 7)
      //   this.close()
      // }
    }
  }
</script>